import { render } from "./history.vue?vue&type=template&id=08eef5fc&scoped=true"
import script from "./history.vue?vue&type=script&lang=js"
export * from "./history.vue?vue&type=script&lang=js"

import "./history.vue?vue&type=style&index=0&id=08eef5fc&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08eef5fc"]])

export default __exports__